// extracted by mini-css-extract-plugin
module.exports = {"container":"Artboard_container__PgkCP"};